import { PayloadAction } from '@reduxjs/toolkit';

import { FontState, FontStatus, UploadedFontData } from 'editor/src/store/fonts/types';

const addUploadedFontsReducer = (state: FontState, action: PayloadAction<UploadedFontData[]>) => {
  const incomingReal = new Set(action.payload.filter((f) => !!f.fileUrl).map((f) => f.fontFile));
  // Evict failed placeholders (no fileUrl) so real fonts can replace them
  state.uploadedFonts = state.uploadedFonts.filter(
    (f) => !(f.loadingStatus === FontStatus.failed && !f.fileUrl && incomingReal.has(f.fontFile)),
  );
  const existingFontFiles = new Set(state.uploadedFonts.map((f) => f.fontFile));
  const existingFilenames = new Set(state.uploadedFonts.map((f) => f.filename.toLowerCase()));
  const newFonts = action.payload.filter(
    (f) => !existingFontFiles.has(f.fontFile) && !existingFilenames.has(f.filename.toLowerCase()),
  );
  state.uploadedFonts = [...newFonts, ...state.uploadedFonts];
};

export default addUploadedFontsReducer;
